import scribdAuthorize from '../../scribd/scribd_oauth.js';

$(function() {
  'use strict';
  const slideshare_object = window.slideshare_object
  const utils = window.slideshare_object.utils;

  function logEventToAmplitude(eventName) {
    const slideshow = slideshare_object.slideshow
      const eventOptions = {
        slideshow_id: slideshow.id,
        slideshow_created_at: slideshow.created_at,
        slideshow_category: slideshare_object.gam_cat_name,
        slideshow_language: slideshow.language,
        slideshow_format: slideshow.type,
        source: "slideshow_view",
      }
      amplitude.getInstance().logEvent(eventName, eventOptions);
  }

  function handleReport (e) {
    if (!utils.isUserAuthenticated()) {
      e.preventDefault();
      e.stopPropagation();
      /**
       * Edge Case Handling: Report is the only action that does not use
       * addAfterLoginEvent, if the user clicks like/follow person, category,
       * comment, clip & click back from Scribd Oauth page, we want to clear
       * the cookie that is set to execute afterLoginEvent
       */
      if (window.cookie('after_login_action') !== null) {
        window.cookie('after_login_action', '', { path: '/', 'max-age': -1 });
      }
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id });
    } else {
      $("#report-slideshow-modal").removeClass("hidden");
      $('body').addClass('no_scroll');
    }
  }

  function handleOpenLikesInfoModal () {
    $("#slideshow-likes-modal").removeClass("hidden");
    $("#slideshow-likes-modal .close").focus();
    $('body').addClass('no_scroll');
  }

  function handleOpenViewsInfoModal () {
    $("#slideshow-views-modal").removeClass("hidden");
    $("#slideshow-views-modal .close").focus();
    $('body').addClass('no_scroll');
  }

  function updateLikeCount (value) {
    var $counter = $('.j-like-count');
    for (let i = 0; i < $counter.length; i++) {
      const counterElem = $($counter[i]);
      var newCount = parseInt(counterElem.attr('data-favorites-count'), 10) + value;
      var populateFavoritesCountOnly = counterElem.attr('data-populate-favorites-count-only');

      counterElem.attr('data-favorites-count', newCount);
      if (populateFavoritesCountOnly === 'true') {
        counterElem.text(newCount);
      } else {
        counterElem.text(utils.i18n('slideshow.foundation_slideview.likes_count', [{ count: newCount }]));
      }
    }
  }

  function getPostDataForLike () {
    return {
      slideshow_id: slideshare_object.presentationId,
      user_id: slideshare_object.user.id,
      source: 'slideviewer'
    };
  }

  function saveSlideshowUnlike () {
    $.post(slideshare_object.favorites.delete_url, getPostDataForLike())
      .then(function() {
        $('.j-like-button').removeClass("liked").attr('data-action', 'like').children('i').removeClass('icon-heart-filled').addClass('icon-heart');
        updateLikeCount(-1);
        logEventToAmplitude("slideshow_unliked");
      });
  }

  function saveSlideshowLike () {
    $.post(slideshare_object.favorites.create_url, getPostDataForLike())
      .then(function() {
        $('.j-like-button').addClass("liked").attr('data-action', 'unlike').children('i').removeClass('icon-heart').addClass('icon-heart-filled');
        updateLikeCount(1);
        logEventToAmplitude("slideshow_liked");
      });
  }

  function handleLike () {
    const dataAction = $('.j-like-button').attr('data-action');

    if (utils.isUserAuthenticated()) {
      if (dataAction === 'like') {
        saveSlideshowLike();
      } else if (dataAction === 'unlike') {
        saveSlideshowUnlike();
      }
    } else {
      var eventConfig = {
        "event": "like",
        "data": { "slideshow_id" : slideshare_object.slideshow.id }
      };
      slideshare_object.addAfterLoginEvent(eventConfig);
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id });
    }
  }

  function handleCloseReportSlideshowModal () {
    $('#report-slideshow-modal').addClass("hidden");
    $('body').removeClass('no_scroll');
  }

  function handleCloseLikesSlideshowModal () {
    $('#slideshow-likes-modal').addClass("hidden");
    $('body').removeClass('no_scroll');
  }

  function handleCloseViewsSlideshowModal () {
    $('#slideshow-views-modal').addClass("hidden");
    $('body').removeClass('no_scroll');
  }

  function handleExpandSlideshowDescription () {
    $('#fade-slideshow-description').addClass('hidden');
    $('#js-expand-description').addClass('hidden');
    $('.slideshow-description-text-wrapper').removeClass('truncated');
  }

  function createElementWithClass (node, className) {
    const element = document.createElement(node);
    element.setAttribute('class', className);
    return element;
  }

  function createNodeWithAttributes (node, attributes) {
    const element = document.createElement(node);
    for (let key in attributes){
      element.setAttribute(key, attributes[key]);
    }
    return element;
  }

  function checkAndAppendText (text, element) {
    if (!!text) {
      element.appendChild(document.createTextNode(text));
    }
  }

  function handleMoreFavorites() {
    const { total, url } = slideshare_object.activities.favorites;
    let favoritesUrl = url;

    const favoritesContainer = $('#favs-list');
    const favoritesRows = $('.likes-row');  
    const offset_param = 'offset=' + favoritesRows.length;

    if (favoritesUrl.indexOf("?") >= 0){
      favoritesUrl += '&' + offset_param;
    } else {
      favoritesUrl += '?' + offset_param;
    }

    fetch(favoritesUrl, { method: 'GET' })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          return response.json().then(result => {
            return Promise.reject({ status: result.status, message: 'Please try again in sometime.' });
          });
        }
      })
      .then(data => {
        const docFragment = data.reduce((accum, favItem) => {
          const likesRowDiv = createElementWithClass('div', 'likes-row');
          const authorPhotoAnchor = createNodeWithAttributes('a', {
            class: 'author-photo-thumbnail',
            alt: 'user thumbnail image',
            title: favItem.login,
            href: `/${favItem.login}?utm_campaign=profiletracking&utm_medium=sssite&utm_source=ssslideshow`
          });
          const lazyLoadThumbImg = createNodeWithAttributes('img', {
            class: 'lazy-thumb-img',
            alt: favItem.login,
            src: favItem.photo
          });
          const authorInfoAnchor = createNodeWithAttributes('a', {
            class: 'author-info',
            alt: 'favoriter information',
            title: favItem.login,
            href: `/${favItem.login}?utm_campaign=profiletracking&utm_medium=sssite&utm_source=ssslideshow`
          });
          const usernameTimeDiv = createElementWithClass('div', 'username-time');
          const usernameSpan = createElementWithClass('span', 'username');
          checkAndAppendText(favItem.user_name, usernameSpan);
          const favtimeSpan = createElementWithClass('span', 'liked-time');
          checkAndAppendText(favItem.summary, favtimeSpan);
          const userInfoDiv = createElementWithClass('div', 'user-info');
          const favoriterRoleSpan = createElementWithClass('span', 'favoriter-role');
          checkAndAppendText(favItem.user_occupation, favoriterRoleSpan);
          const favoriterOrgSpan = createElementWithClass('span', 'favoriter-org');
          favoriterOrgSpan.appendChild(document.createTextNode(favItem.user_organization));
          checkAndAppendText(favItem.user_organization, favoriterOrgSpan);

          authorPhotoAnchor.appendChild(lazyLoadThumbImg);
          usernameTimeDiv.appendChild(usernameSpan)
          usernameTimeDiv.appendChild(favtimeSpan);
          userInfoDiv.appendChild(favoriterRoleSpan)
          userInfoDiv.appendChild(favoriterOrgSpan);
          authorInfoAnchor.appendChild(usernameTimeDiv)
          authorInfoAnchor.appendChild(userInfoDiv);

          likesRowDiv.appendChild(authorPhotoAnchor)
          likesRowDiv.appendChild(authorInfoAnchor);
  
          accum.appendChild(likesRowDiv);
          return accum;
        }, document.createDocumentFragment());
        favoritesContainer.append(docFragment);

        if ($('.likes-row').length == total) {
          $('.more-container').hide();
        }
      })
      .catch(error => {
        throw new Error('Error fetching more favorites information');
      });
  }

  $('.j-like-button').on('click', handleLike);
  
  $('#slideshow-likes-modal-trigger').on('click', handleOpenLikesInfoModal);
  $('#slideshow-likes-modal .close').on('click', handleCloseLikesSlideshowModal);
  $('#slideshow-likes-modal .mobile-back-button').on('click', handleCloseLikesSlideshowModal);
  $("#slideshow-likes-modal-backdrop").on("click", handleCloseLikesSlideshowModal);
  
  $('#slideshow-views-modal-trigger').on('click', handleOpenViewsInfoModal);
  $('#slideshow-views-modal .close').on('click', handleCloseViewsSlideshowModal);
  $('#slideshow-views-modal .mobile-back-button').on('click', handleCloseViewsSlideshowModal);
  $("#slideshow-views-modal-backdrop").on("click", handleCloseViewsSlideshowModal);

  $('.report').on('click', handleReport);
  $('#report-slideshow-modal .close').on('click', handleCloseReportSlideshowModal);
  $("#report-slideshow-modal-backdrop").on("click", handleCloseReportSlideshowModal);

  $('#js-expand-description').on('click', handleExpandSlideshowDescription);
  $('.j-more-favs').on('click', handleMoreFavorites);
});


window.addEventListener('DOMContentLoaded', () => {
  const truncateLength = 200;
  const descriptionText = $('#slideshow-description-text').html();

  if (descriptionText && descriptionText.length > truncateLength) {
    $('#fade-slideshow-description').removeClass('hidden');
    $('#js-expand-description').removeClass('hidden');
    $('.slideshow-description-text-wrapper').addClass('truncated');
  }
});
